import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import styled from 'styled-components';
import TextField from '../SolvPatternLibrary/TextField';

class MaskedTextField extends Component {
  state = {
    textMask: '',
  };

  getCustomMaskedInput = inputProps => {
    const { inputRef, ...other } = inputProps;
    const { mask, placeholderChar, showMask } = this.props;
    const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    return (
      <MaskedInput
        {...other}
        mask={mask || dateMask}
        placeholderChar={placeholderChar || '\u2000'}
        showMask={showMask}
      />
    );
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  render = () => {
    const { textMask } = this.state;
    const { mask, placeholderChar, value, onChange, className, inputProps, ...others } = this.props;
    const MaskedTextFieldProps = {
      ...others,
      className,
      InputProps: {
        value: value || textMask,
        onChange: onChange || this.handleChange('textMask'),
        inputComponent: this.getCustomMaskedInput,
        ...others,
      },
      inputProps: {
        ...inputProps,
      },
    };
    return <TextField {...MaskedTextFieldProps} />;
  };
}

MaskedTextField.propTypes = {
  mask: PropTypes.array,
  inputProps: PropTypes.object,
  placeholderChar: PropTypes.string,
  showMask: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  className: PropTypes.string,
};

export const MaskedPhoneTextField = props => (
  <MaskedTextField
    {...props}
    mask={['(', /[2-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]} // jscs: disable
  />
);

const CodeTextField = styled(MaskedTextField)`
  & input {
    text-indent: 0;
    text-align: center;
    letter-spacing: 5px;
  }
  & p {
    text-indent: 0;
  }
`;
export const MaskedCodeTextField = props => (
  <CodeTextField {...props} mask={[/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]} placeholderChar="-" />
);

export default MaskedTextField;
